import { observer } from 'mobx-react';
import React from 'react';
import { VerificationForm } from './VerificationForm';
import { LoginForm } from './LoginForm';
import { LoginStore } from './LoginStore';
import { consumeLoggedOut } from '~/lib/helper/LogoutHelper';
import { logoutZendeskMessenger, whenZendeskSnippetReady } from '~/lib/helper/ZendeskHelper';

interface LoginPaneProps {
    redirectUrl?: string;
}

@observer
export default class LoginPane extends React.Component<LoginPaneProps> {
    loginStore: LoginStore;

    constructor(props: LoginPaneProps) {
        super(props);
        this.loginStore = new LoginStore(this.props.redirectUrl);
    }

    componentDidMount(): void {
        this.loginStore.init();
        if (consumeLoggedOut()) {
            this.loginStore.setShowLoggedOut(true);
            // Repeats /logout's best-effort Zendesk logout.
            void whenZendeskSnippetReady().then(logoutZendeskMessenger);
        }
    }

    render() {
        if (this.loginStore.codeInput !== 'none') {
            return <VerificationForm store={this.loginStore} />;
        }
        return <LoginForm store={this.loginStore} />;
    }
}
